import styled from "styled-components";
import theme from "theme";

export const SideBarItemsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.2rem;

    @media (${theme.breakpoints.mobileL}) {
        flex-direction: row;
        max-width: 100%;
        overflow-x: scroll;

        ::-webkit-scrollbar {
            display: none;
        }
    }
`;
